import type { CodeableConcept } from '@medplum/fhirtypes'
import { codeableConcept } from '#src/codeableConcept.ts'
import { ASSESSMENT_TYPE, INCIDENT_TYPE } from '#src/codeSystems.ts'

export const ASSESSMENT_TYPES = {
  INITIAL: codeableConcept({
    system: ASSESSMENT_TYPE,
    code: 'initial',
    display: 'Initial',
  }),
  SEMI_ANNUAL: codeableConcept({
    system: ASSESSMENT_TYPE,
    code: 'semi-annual',
    display: '180 Days',
  }),
  CHANGE_OF_CARE: codeableConcept({
    system: ASSESSMENT_TYPE,
    code: 'change-of-care',
    display: 'Change of Condition',
  }),
  SDR: codeableConcept({
    system: ASSESSMENT_TYPE,
    code: 'sdr',
    display: 'SDR',
  }),
  CHANGE_OF_RESIDENCE: codeableConcept({
    system: ASSESSMENT_TYPE,
    code: 'change-of-residence',
    display: 'Change of Residence',
  }),
} satisfies Record<string, CodeableConcept>

export const INCIDENT_TYPES = {
  INCIDENT_LEVEL_ONE: codeableConcept({
    system: INCIDENT_TYPE,
    code: 'level-one',
    display: 'Level One Incident',
  }),
  INCIDENT_LEVEL_TWO: codeableConcept({
    system: INCIDENT_TYPE,
    code: 'level-two',
    display: 'Level Two Incident',
  }),
  FALL_LEVEL_ONE: codeableConcept({
    system: INCIDENT_TYPE,
    code: 'fall-level-one',
    display: 'Fall Level One',
  }),
  FALL_LEVEL_TWO: codeableConcept({
    system: INCIDENT_TYPE,
    code: 'fall-level-two',
    display: 'Fall Level Two',
  }),
  MEDICATION_ERROR: codeableConcept({
    system: INCIDENT_TYPE,
    code: 'medication-error',
    display: 'Medication Error',
  }),
  EMERGENCY_ROOM_VISIT: codeableConcept({
    system: INCIDENT_TYPE,
    code: 'emergency-room-visit',
    display: 'Emergency Room Visit',
  }),
} satisfies Record<string, CodeableConcept>
